import toDate from '../to-date';

export const getMonth = (date: Date | number): number => {
  const formattedDate = toDate(date);

  return formattedDate.getMonth();
};

export default getMonth;
